module.exports = __webpack_public_path__ + "img/timeline-02.d0fb0114.jpg";